<template>
  <div class="app" id="app">
    <HeaderContainer />
    <ResultImageContainer />
    <div class="app__content" v-on:scroll="getScrollTop" ref="appContent">
      <router-view />
    </div>
    <GDPRToastContainer />
    <ModalContainer />
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import { Routes, Modules } from "@/constants";
import { getConstentCookie } from "@/utils";

import HeaderContainer from "@/containers/HeaderContainer";
import ResultImageContainer from "@/containers/ResultImageContainer";
import GDPRToastContainer from "@/containers/GDPRToastContainer";
import ModalContainer from "@/containers/ModalContainer";

export default {
  name: "App",
  data() {
    return {
      scrollTopPosition: 0
    };
  },
  components: {
    HeaderContainer,
    ResultImageContainer,
    GDPRToastContainer,
    ModalContainer
  },
  computed: {
    ...mapState({
      scrollContentTrigger: state => state.scrollContentTrigger,
      loadedSettingsProgress: state => state.loadedSettingsProgress
    })
  },
  methods: {
    ...mapMutations({
      setScrollContentPosition: "setScrollContentPosition"
    }),
    scrollContentToTop: function() {
      const appContent = this.$refs.appContent;
      appContent.scrollTop = 0;
    },
    getScrollTop: function() {
      const currentScrollTOp = this.$refs.appContent.scrollTop;
      this.scrollTopPosition = currentScrollTOp;
      this.setScrollContentPosition(currentScrollTOp);
    }
  },
  watch: {
    scrollContentTrigger: function() {
      this.scrollContentToTop();
    },
    loadedSettingsProgress: function(value) {
      if (value.length === Modules.total) {
        getConstentCookie();
        setTimeout(() => {
          this.$router.push(Routes.home.path);
        }, 500);
      }
    }
  },
  mounted() {
    this.$router.push(Routes.loading.path);
  }
};
</script>

<style lang="scss" scoped>
.app {
  height: 100vh;
  overflow: hidden;
  width: 100vw;

  &__content {
    height: 100%;
    padding-top: sizes("header") + spacer("m");
    position: relative;
    z-index: z-index("content");
    overflow-y: auto;
    overflow-x: hidden;

    @include if-tablet {
      padding-top: sizes("header") + spacer("l");
    }
  }
}
</style>
